import { CampaignsTracker } from '@lessonnine/marketing-tracker';
import { getMyEnv } from '@lessonnine/my.js';

const PPF_SHORTLINK = 'my-babbel-product-preview';

const setCampaignsTracker = () => {
  const { goBaseUrl } = getMyEnv();
  const campaignsTracker = new CampaignsTracker({ host: goBaseUrl });
  campaignsTracker.trackUserClick();
  campaignsTracker.trackPageview(PPF_SHORTLINK);
};

setCampaignsTracker();

export default setCampaignsTracker;
